var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.065 47.979 L 5.264 31.928 c -0.979 -0.565 -0.786 -2.032 0.306 -2.325 l 20.908 -5.599 c 1.236 -0.331 2.507 0.403 2.839 1.639 l 5.608 20.908 C 35.218 47.643 34.044 48.544 33.065 47.979 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(79,187,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.777 61.556 l 11.482 -19.889 L 13.633 33.8 L 0.516 56.521 c -1.292 2.238 0.323 5.035 2.907 5.035 H 15.777 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(79,187,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.426 68.078 v 10.816 c 0 0.912 -0.739 1.651 -1.651 1.651 h -6.266 c -3.339 0 -6.424 -1.785 -8.087 -4.681 l -4.804 -8.364 c -1.01 -1.759 -1.542 -3.752 -1.542 -5.78 l 0 0 c 0.121 1.579 1.364 2.974 3.102 3.096 h 17.597 c 0.912 0 1.651 0.739 1.651 1.651 V 68.078 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(57,151,62)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.069 37.017 l 27.801 -16.051 c 0.979 -0.565 2.153 0.336 1.86 1.428 L 74.124 43.3 c -0.331 1.236 -1.602 1.97 -2.839 1.639 l -20.91 -5.597 C 49.283 39.05 49.089 37.583 50.069 37.017 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(79,187,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.955 15.257 l 11.483 19.888 l 13.626 -7.867 L 58.946 4.558 c -1.292 -2.238 -4.522 -2.238 -5.814 0 L 46.955 15.257 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(79,187,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.982 17.754 l -9.367 -5.408 c -0.79 -0.456 -1.06 -1.466 -0.604 -2.256 l 3.133 -5.427 c 1.67 -2.892 4.758 -4.67 8.097 -4.663 l 9.646 0.021 c 2.028 0.004 4.02 0.54 5.776 1.555 l 0 0 c -1.428 -0.685 -3.257 -0.306 -4.232 1.139 l -8.799 15.24 c -0.456 0.79 -1.466 1.06 -2.256 0.604 L 37.982 17.754 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(57,151,62)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.207 56.627 v 32.101 c 0 1.131 -1.367 1.697 -2.166 0.897 L 33.738 74.318 c -0.905 -0.905 -0.905 -2.373 0 -3.278 l 15.303 -15.31 C 49.84 54.93 51.207 55.496 51.207 56.627 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(79,187,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.609 64.811 l -22.965 0 l 0 15.734 l 26.235 -0.001 c 2.584 0 4.199 -2.797 2.907 -5.035 L 71.609 64.811 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(79,187,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.933 55.791 l 9.367 -5.408 c 0.79 -0.456 1.8 -0.185 2.256 0.604 l 3.133 5.427 c 1.67 2.892 1.666 6.456 -0.01 9.344 l -4.841 8.343 c -1.018 1.754 -2.478 3.211 -4.234 4.225 l 0 0 c 1.307 -0.894 1.893 -2.668 1.13 -4.234 l -8.799 -15.24 c -0.456 -0.79 -0.185 -1.8 0.604 -2.256 L 73.933 55.791 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(57,151,62)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.d7fae02b7ce9dd1e9f11ddd7a0f9fa65.svg";
export { ForwardRef as ReactComponent };